<ion-header>
  <ion-toolbar>
    <ion-title>Model inferencing history</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal('close')">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
  
<ion-content class="no-hover-page" [fullscreen]="true" >
  
  <ng-container>
    <!-- <ion-grid> -->
      <!-- <ion-row> -->
        <!-- <h3>put title here</h3> -->
      <!-- </ion-row> -->
      <ion-row>
        <div *ngFor="let item of historyData">
          <div *ngFor="let key of objectKeys(item)" style="padding: 5px;text-align: left;">
            {{key}}
          </div>
        </div>
      </ion-row>
      <ion-row>
        <!-- Table Headers -->
        <ion-col><strong>Model</strong></ion-col>
        <ion-col><strong>Usability</strong></ion-col>
        <ion-col><strong>Intonation</strong></ion-col>
        <ion-col><strong>Remarks</strong></ion-col>
        <ion-col><strong>Mispronounced words</strong></ion-col>
        <ion-col><strong>Not recorded words</strong></ion-col>
        <ion-col><strong>Verified by</strong></ion-col>
      </ion-row>
      
  
      <!-- Table Data Rows -->
      <div *ngFor="let item of historyData">
        <div *ngFor="let key of objectKeys(item)">
          <div *ngFor="let modelKey of objectKeys(item[key])">
            <ion-row *ngFor="let fileName of objectKeys(item[key][modelKey]);">
              <ion-col>{{ modelKey }}</ion-col>
              <ion-col>{{ item[key][modelKey][fileName].usability }}</ion-col>
              <ion-col>{{ item[key][modelKey][fileName].intonation }}</ion-col>

              <ion-col>{{ item[key][modelKey][fileName].remarks !== null ? item[key][modelKey][fileName].remarks : '' }}</ion-col>
              <ion-col>{{ item[key][modelKey][fileName].mispronounced_words !== null ? item[key][modelKey][fileName].mispronounced_words : '' }}</ion-col>
              <ion-col>{{ item[key][modelKey][fileName].not_recorded_mispronounced_words !== null ? item[key][modelKey][fileName].not_recorded_mispronounced_words : '' }}</ion-col>
              <ion-col>{{ item[key][modelKey][fileName].verified_by !== null ? item[key][modelKey][fileName].verified_by : '' }}</ion-col>




            
              <!-- <ion-col> -->
                <!-- <audio controls *ngIf="item.Audiopath">
                  <source [src]="item.Audiopath" type="audio/mpeg" />
                  Your browser does not support the audio element.
                </audio> -->
              <!-- </ion-col> -->
              
              
            </ion-row>
          </div>
        </div>
      </div>


    
      

      


  
      
      
      
    <!-- </ion-grid> -->

    <!-- <div *ngIf="historyData.length > 0">
      <div *ngFor="let item of historyData">
          <div *ngFor="let key of objectKeys(item)">
              <h3>{{ key }}</h3> 
              <div *ngFor="let modelKey of objectKeys(item[key])">
                  <h4>{{ modelKey }}</h4> 
                  <ul>
                      <li *ngFor="let fileName of objectKeys(item[key][modelKey])">
                          <strong>{{ fileName }}:</strong>
                          <ul>
                              <li>Remarks: {{ item[key][modelKey][fileName].remarks }}</li>
                              <li>Usability: {{ item[key][modelKey][fileName].usability }}</li>
                              <li>Intonation: {{ item[key][modelKey][fileName].intonation }}</li>
                              <li>Mispronounced Words: {{ item[key][modelKey][fileName].mispronounced_words }}</li>
                          </ul>
                      </li>
                  </ul>
              </div>
          </div>
      </div>
  </div> -->
  
    
  </ng-container>
  
</ion-content>
    

  
